angular.module('mychart').controller('CompleteChartModalCtrl',
    ['$scope', '$uibModalInstance', '$sce', '$window', 'PersonRepository', 'MyMessagesService', 'activePatient',
        function ($scope, $modalInstance, $sce, $window, PersonRepository, MyMessagesService, activePatient) {
            'use strict';

            $scope.activePatient = activePatient;

            $scope.loadingCompleteChart = true;
            $scope.displayPrintButton = false;

            $scope.isCompleteChartError = false;
            $scope.completeChartErrorMessage = '';

            $scope.model = {
                CompleteChartData: '',
                PatientId: '',
                FullName: activePatient.fullName
            };

            function loadCompleteChart() {
                $scope.loadingCompleteChart = true;
                $scope.removeHttpError();

                PersonRepository.getCompleteChart($scope.activePatient.id)
                    .then(function (data) {
                        var completeChartUrl = 'data:application/pdf;base64,' + data.PatientChart;
                        //var completeChartUrl = 'data:application/pdf,' + data.PatientChart;
                        $scope.model.CompleteChartData = $sce.trustAsResourceUrl(completeChartUrl);
                        $scope.model.PatientId = data.PatientId;
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                        $scope.isCompleteChartError = true;
                        $scope.model.CompleteChartErrorMessageHtml = $sce.trustAsHtml(MyMessagesService.replaceLineBreaksWithHtmlLineBreak(response.data));
                    })
                    .finally(function() {
                        $scope.loadingCompleteChart = false;
                    });
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            function print() {
                $window.print();
            }


            $scope.ok = ok;
            $scope.cancel = cancel;
            $scope.print = print;

            loadCompleteChart();
        }]);